import { UIDragListHandle } from 'ui-addon-draggable-compat';
export default UIDragListHandle;